export default __webpack_public_path__ + "static/media/552.4f830f4c.jpg";